import { RoutingRuleListTableRowData } from '../types';
import {
    RoutingRulesListFilterSchemaKeys,
    RoutingRulesListFilterValues,
} from '../../../schemas/routingRulesListFilterSchema';
import { stringToStringArray } from '../../../utils/convert';

export const filterRoutingRuleTableRow =
    (filters: RoutingRulesListFilterValues | null) => (row: RoutingRuleListTableRowData) => {
        if (!filters || !Object.keys(filters).length) {
            return true;
        }

        const {
            [RoutingRulesListFilterSchemaKeys.Name]: name,
            [RoutingRulesListFilterSchemaKeys.Timing]: timings,
            [RoutingRulesListFilterSchemaKeys.Companies]: companies,
            [RoutingRulesListFilterSchemaKeys.TravelAgencies]: travelAgencies,
        } = filters;

        const companiesArray = companies && stringToStringArray(companies);
        const travelAgenciesArray = travelAgencies && stringToStringArray(travelAgencies);

        if (name && !row.name?.includes(name)) {
            return false;
        }

        if (timings && !timings.includes(row.timing)) {
            return false;
        }

        if (companiesArray?.length && !row.conditions.companies.some(({ id }) => companiesArray.includes(id))) {
            return false;
        }

        if (
            travelAgenciesArray?.length &&
            !row.conditions.travelAgencies.some(({ id }) => travelAgenciesArray.includes(id))
        ) {
            return false;
        }

        return true;
    };

export const filterRoutingRuleTableRowByGlobalSearch = (searchQuery: string) => (row: RoutingRuleListTableRowData) => {
    const match = (value: string | undefined | null) =>
        value?.toLocaleLowerCase().includes(searchQuery.toLocaleLowerCase());

    if (match(row.name)) {
        return true;
    }

    if ([...row.conditions.companies, ...row.conditions.travelAgencies].some(({ name }) => match(name))) {
        return true;
    }

    if (row.services.some(({ serviceName }) => match(serviceName))) {
        return true;
    }

    return false;
};
